import { useEffect, useState } from "react";
import { areaColor } from "../../../config/enum";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";

import Moment from "react-moment";

import { getCommentary } from "../../../api/ordercoms";

import { useSelector } from "react-redux";
import CreateEditOrderCommentaries from "customComponents/devicesComponents/CreateEditOrderCommentaries";

export default function OrderComs({ user }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const currentOrder = useSelector((state) => state.orders.currentOrder);

  const [commentaries, setCommentaries] = useState([]);
  const [orderCommentaryRows, setOrderCommentaryRows] = useState([]);

  async function fetchCommentaries() {
    const response = await getCommentary(currentOrder.order_id);
    setCommentaries([
      ...new Map(response.data.map((item) => [item["commentary_id"], item])).values(),
    ]);
  }

  useEffect(() => {
    if (currentOrder) {
      fetchCommentaries();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrder]);

  useEffect(() => {
    setOrderCommentaryRows(generateRows);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentaries]);

  const orderCommentaryColumns = [
    { Header: "Nom et Date", accessor: "name", align: "center", width: "10%" },
    { Header: "Commentaire", accessor: "commentary", align: "center", width: "90%" },
  ];

  function generateRows() {
    const rows = [];
    for (let i = 0; i < commentaries.length; i++) {
      rows.push({
        name: (
          <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1}>
              <MDTypography display="block" variant="button" fontWeight="medium">
                {commentaries[i] && commentaries[i].commentary_user_name !== null
                  ? commentaries[i].commentary_user_name
                  : "Utilisateur inconnu"}
              </MDTypography>
              <MDTypography component="a" variant="button" fontWeight="medium">
                {commentaries[i] && commentaries[i].commentary_date ? (
                  <MDBox display="flex" alignItems="center" lineHeight={1}>
                    <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                      <MDTypography display="block" variant="caption">
                        le{" "}
                        <b>
                          <Moment format="DD/MM/YYYY">
                            {commentaries[i] && commentaries[i].commentary_date}
                          </Moment>
                        </b>
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                ) : (
                  <MDBox display="flex" alignItems="center" lineHeight={1}>
                    <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                      <MDTypography
                        display="block"
                        variant="caption"
                        color="error"
                        fontWeight="medium"
                      >
                        Date inconnue
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                )}
              </MDTypography>
            </MDBox>
          </MDBox>
        ),
        commentary: (
          <>
            {commentaries[i] && commentaries[i].commentary_action ? (
              <MDTypography
                component="a"
                sx={(theme) => ({
                  display: "block",
                  whiteSpace: "normal",
                  overflowWrap: "break-word",
                  maxWidth: {
                    xl: theme.breakpoints.values.lg,
                    lg: theme.breakpoints.values.md,
                    md: theme.breakpoints.values.sm,
                    sm: theme.breakpoints.values.sm,
                    xs: theme.breakpoints.values.sm,
                  },
                })}
                variant="button"
                fontWeight="medium"
              >
                {commentaries[i] && commentaries[i].commentary_action}
              </MDTypography>
            ) : (
              <MDBox lineHeight={1} sx={{ textAlign: "center", width: "100%" }}>
                <MDTypography display="block" variant="caption" color="error" fontWeight="medium">
                  Non spécifié
                </MDTypography>
              </MDBox>
            )}
          </>
        ),
      });
    }
    return rows;
  }

  return (
    <Grid item xs={12} mt={6} mb={3}>
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          style={{
            backgroundColor: currentOrder && areaColor[currentOrder.area],
            boxShadow: `0 1px 4px 1px ${currentOrder && areaColor[currentOrder.area]}`,
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              width: "50%",
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color="white"
          >
            Commentaires de la commande
          </MDTypography>
          {user &&
            (user.role === "Contremaître" ||
              user.role === "Chef d'agence" ||
              user.role === "Admin" ||
              user.role === "Pilote" ||
              user.role === "Assistante de gestion") && (
              <Grid style={{ textAlign: "right", width: "50%" }}>
                <CreateEditOrderCommentaries
                  edit={false}
                  commentaries={commentaries}
                  setCommentaries={setCommentaries}
                  order={currentOrder}
                />
                {commentaries.length > 0 && (
                  <CreateEditOrderCommentaries
                    edit
                    commentaries={commentaries}
                    setCommentaries={setCommentaries}
                    order={currentOrder}
                  />
                )}
              </Grid>
            )}
        </MDBox>

        {orderCommentaryRows && orderCommentaryRows.length === 0 ? (
          <MDBox pt={0.75} sx={{ textAlign: "center", paddingTop: 3, paddingBottom: 2 }}>
            <MDTypography
              component="a"
              variant="h5"
              color={darkMode ? "white" : "inherit"}
              style={{
                display: "tableCell",
                verticalAlign: "middle",
              }}
            >
              Aucun commentaire n'a encore été ajouté
            </MDTypography>
          </MDBox>
        ) : (
          <MDBox pt={0.75} sx={{ textAlign: "center" }}>
            <DataTable
              table={{ columns: orderCommentaryColumns, rows: orderCommentaryRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
          </MDBox>
        )}
      </Card>
    </Grid>
  );
}
